import { useState } from "react";
import { ClipboardList } from "lucide-react";
import { AuditCard } from "./AuditCard";
import type { AuditListItem } from "./chatCardUtils";

const MAX_VISIBLE = 5;

interface AuditListCardProps {
  audits: AuditListItem[];
}

export function AuditListCard({ audits }: AuditListCardProps) {
  const [showAll, setShowAll] = useState(false);

  if (!audits.length) return null;

  const visible = showAll ? audits : audits.slice(0, MAX_VISIBLE);
  const remaining = audits.length - MAX_VISIBLE;

  return (
    <div className="mt-2 space-y-1.5">
      <div className="flex items-center gap-1.5 text-[11px] font-medium text-muted uppercase tracking-wider">
        <ClipboardList size={12} />
        <span>
          {audits.length} audit{audits.length !== 1 ? "s" : ""} found
        </span>
      </div>
      <div className="space-y-1.5">
        {visible.map((audit) => (
          <AuditCard key={audit.id} audit={audit} />
        ))}
      </div>
      {remaining > 0 && !showAll && (
        <button
          type="button"
          onClick={() => setShowAll(true)}
          className="text-xs text-accent hover:text-accent/80 transition-colors font-medium"
        >
          +{remaining} more
        </button>
      )}
    </div>
  );
}
